import React from 'react';

import {hooks} from '../hooks';
import {theme} from '../constants';
import {components} from '../components';
import { createOrder } from '../services/handleCheckout';
import { toast } from 'react-toastify';

export const Checkout: React.FC = () => {
  const navigate = hooks.useAppNavigate();
  const dispatch = hooks.useAppDispatch();

  const cart = hooks.useAppSelector(state => state.cartSlice.list);
  const payAmount = hooks.useAppSelector(state => state.cartSlice.payAmount);
  const discountAmount = hooks.useAppSelector(state => state.cartSlice.discountAmount);
  const promoCode = hooks.useAppSelector(state => state.cartSlice.promoCode);


  const [loading, setLoading] = React.useState(false);
  const token = hooks.useAppSelector(state => state.auth.token);

  const submitOrder = async () => {
    try {
      setLoading(true);
      const orderPayload = {
        items: cart.map(item => ({
          id: item.id,
          title:item.title,
          quantity: item.quantity,
        })),
        discount_code:promoCode,
      };
      await createOrder(orderPayload, token, dispatch, navigate);

      navigate('/OrderSuccessful');
    } catch (error: any) {
      toast.error(error.message || 'خطا در ثبت سفارش');

    } finally {
      setLoading(false);
    }
  };

  const textStyle = {
    margin: 0,
    fontSize: 14,
    lineHeight: 1.5,
    fontWeight: 400,
    color: theme.colors.textColor,
    ...theme.fonts.Mulish_400Regular,
  };

  const renderHeader = (): JSX.Element => {
    return <components.Header title='تسویه حساب' goBack={true} line={true} />;
  };

  const renderMyOrder = (): JSX.Element => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          borderRadius: 15,
          marginBottom: 30,
        }}
      >
        <div
          style={{
            display: 'flex',
            ...theme.flex.rowCenterSpaceBetween,
            marginBottom: 8,
            padding: '0 20px 6px 20px',
          }}
        >
          <h4
            style={{
              margin: 0,
              ...theme.fonts.Mulish_700Bold,
              color: theme.colors.mainColor,
              lineHeight: 1.2,
              fontSize: 18,
            }}
          >
            جمع کل فاکتور
          </h4>
          <h4
            style={{
              margin: 0,
              ...theme.fonts.Mulish_700Bold,
              color: theme.colors.mainColor,
              lineHeight: 1.2,
              fontSize: 18,
            }}
          >
            {`${payAmount.toLocaleString()} تومان`}
          </h4>
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            backgroundColor: theme.colors.ghostWhite,
            padding: 20,
            borderTop: 'solid #EDF1FA 4px',
            borderBottom: 'solid #EDF1FA 4px',
            borderColor: theme.colors.ghostWhite2,
          }}
        >
          {/* محصولات */}
          {cart.map((item, index) => {
            return (
              <div
                key={index}
                style={{
                  ...theme.flex.rowCenterSpaceBetween,
                  marginBottom: 10,
                  display: 'flex',
                  alignItems: 'center',
                  flexDirection: 'row',
                }}
              >
                <h6
                  style={{
                    textTransform: 'capitalize',
                    margin: 0,
                    color: theme.colors.textColor,
                    fontSize: 14,
                    ...theme.fonts.Mulish_400Regular,
                    fontWeight: 400,
                    lineHeight: 1.5,
                  }}
                >
                  {item.title}
                  {/* {item.color && `، ${item.color}`} */}
                </h6>
                <span
                  style={{
                    textTransform: 'capitalize',
                    margin: 0,
                    color: theme.colors.textColor,
                    fontSize: 14,
                    ...theme.fonts.Mulish_400Regular,
                    fontWeight: 400,
                    lineHeight: 1.5,
                  }}
                >
                  {item.quantity} × {`${item.price.toLocaleString()} تومان`}
                </span>
              </div>
            );
          })}
          {/* مجموع تخفیف */}
          {discountAmount > 0 && (
            <div
              style={{
                display: 'flex',
                ...theme.flex.rowCenterSpaceBetween,
                marginBottom: 10,
              }}
            >
              <div style={{textTransform: 'capitalize'}}>مبلغ کل تخفیف </div>
              <div style={{textTransform: 'capitalize'}}>{discountAmount.toLocaleString()} تومان</div>
            </div>
          )}
          {/* ارسال */}
          {/* <div style={{...theme.flex.rowCenterSpaceBetween, display: 'flex'}}>
            <h6
              style={{
                textTransform: 'capitalize',
                margin: 0,
                color: theme.colors.textColor,
                fontSize: 14,
                ...theme.fonts.Mulish_400Regular,
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              ارسال
            </h6>
            <span
              style={{
                textTransform: 'capitalize',
                margin: 0,
                color: '#51BA74',
                fontSize: 14,
                ...theme.fonts.Mulish_400Regular,
                fontWeight: 400,
                lineHeight: 1.5,
              }}
            >
              {`${delivery === 0 ? 'رایگان' : `${delivery.toFixed(2)} تومان`}`}
            </span>
          </div> */}
        </div>
      </div>
    );
  };



  const renderButton = (): JSX.Element => {
    return (
      <components.Button
      title={loading ? 'در حال ارسال...' : 'سفارش را تایید کنید'}
      onClick={submitOrder}
      disabled={loading}
      containerStyle={{
        padding: '0 20px',
      }}
    />
    )
  };

  const renderContent = (): JSX.Element => {
    return (
      <div style={{paddingTop: 33, paddingBottom: 20}}>
        {renderMyOrder()}
        {renderButton()}
      </div>
    );
  };

  return (
    <>
      {renderHeader()}
      {renderContent()}
    </>
  );
};
